import React from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";
export default function SoftwareSkill() {
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {skillsSection.softwareSkills.map((skills, i) => {
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skills.skillName}
              >
                <img src={"tech_icon/" + skills.srcPath} alt="1" width="70px" height="70px"/>
                <p style={{fontSize:"1rem"}}>{skills.skillName}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
